function validateNumber(value) {
  const numValue = Number(value);
  const strValue = String(value);
  if (!strValue) return 'Required';
  if (/,/.test(value)) {
    return `Change comma for a dot. (e.g. ${value.replace(/,/, '.')})`;
  }
  if (isNaN(value)) return 'Must be a number';
  if (numValue < 0) return 'Must be positive';
  if (numValue > 0 && numValue < 100) return 'Price must be greater than or equal to $1, or $0';
  if (strValue.match(/\./) && strValue.split('.')[1].length > 2) {
    return 'Maximum of two decimal points';
  }
}

export default function validate(values) {
  const errors = {};
  const validateMonthlyPriceInCents = validateNumber(values.monthly_price_in_cents);

  if (validateMonthlyPriceInCents) {
    errors.monthlyPriceInCents = validateMonthlyPriceInCents;
  }

  return errors;
}
